import React, { Component } from 'react';
import { Strings } from "../../../Resources/Strings/i18n";
import resendIcon from '../../../Resources/Images/ic_send_black.png';
import delIcon from '../../../Resources/Images/ic_remove_black.png';
import DateUtils from '../../../Utils/DateUtils';
import CommonUtils from "../../../Utils/CommonUtils";
import { COLORLIST } from '../../../Constants';
import './Report.scss';

class ReportScheduleCard extends Component {
    constructor(props) {
        super(props)
    }

    getSchedule = () => {
        let schedule = this.props.rSchedule
        var day = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday",]
        if(schedule.frequency === "DAILY") {
            return(`${schedule.frequency}: ${DateUtils.convertUTCDateToLocalDate(schedule.time)}`)
        }
        else if(schedule.frequency === "WEEKLY") {
            return(`${schedule.frequency}: ${day[schedule.day]}, ${DateUtils.convertUTCDateToLocalDate(schedule.time)}`)
        }
        else if(schedule.frequency === "MONTHLY") {
            return(`${schedule.frequency}: ${DateUtils.getDateOrdinal(schedule.date)}, ${DateUtils.convertUTCDateToLocalDate(schedule.time)}`)
        }
    }
    render () {
        return (
            <div className="recipientCard" style={{backgroundColor: CommonUtils.getColorByIndex(this.props.index, COLORLIST)}}>
                    <div className="cardName">{this.props.rName}</div>
                    <div className="cardMiddleRow">
                        <div className="cardEmail">{this.props.rEmail}</div>
                        <div className="cardIconContainer">
                            <span className="cardIcon" onClick={this.props.resendReport}>
                                <img src={resendIcon} alt={Strings("resend")} />
                            </span>
                            <span className="cardIcon" onClick={()=>{this.props.deleteReport(this.props.recipientId)}}>
                                <img src={delIcon} alt={Strings("Cancel")} />
                            </span>
                        </div>
                    </div>
                    <div className="cardSchedule">{this.getSchedule()}</div>
                
            </div>
        )
    }
}

export default ReportScheduleCard;

/*
    day: null
​​​
    frequency: "DAILY"
    ​​​
    isResend: false
    ​​​
    time: "2021-04-19T17:00:00.000Z"
    ​​​
    type: "RECURRING"
*/